(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gk-faq-terms-split"] && !Shopify.designMode) return;
  try {
    
const bindGkFaqOverlay = scope => {
  const sections = []

  if (scope instanceof Element && scope.matches('.gk-faq-terms-split')) {
    sections.push(scope)
  }

  if (scope.querySelectorAll) {
    scope.querySelectorAll('.gk-faq-terms-split').forEach(section => sections.push(section))
  }

  sections.forEach(section => {
    if (section.dataset.gkFaqOverlayBound === 'true') return
    section.dataset.gkFaqOverlayBound = 'true'

    const items = Array.from(section.querySelectorAll('.gk-faq-terms-split__accordion > details'))

    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if (!item.open) return

        items.forEach(other => {
          if (other !== item && other.open) other.open = false
        })
      })
    })

    section.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return

      const openItem = items.find(item => item.open)
      if (!openItem) return

      openItem.open = false
      const summary = openItem.querySelector('summary')
      if (summary) summary.focus()
    })
  })
}

bindGkFaqOverlay(document)
document.addEventListener('shopify:section:load', event => bindGkFaqOverlay(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk-golfbanor-directory"]) return;
  try {
    
(() => {
  const rootSelector = '[data-gk-golf-directory]';

  const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'})[char]);

  const normalizeCity = (value) =>
    typeof value === 'string'
      ? value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('sv-SE')
      : '';

  const getPostalCode = (club) => {
    const possibleValues = [
      club?.postal_code,
      club?.postalCode,
      club?.zip_code,
      club?.zipCode,
      club?.zip,
      club?.postnummer
    ];

    for (const value of possibleValues) {
      if (value === null || value === undefined) continue;
      const digits = String(value).replace(/\D/g, '').slice(0, 5);
      if (digits.length === 5) return Number(digits);
    }

    return null;
  };

  const getRegionFromPostalCode = (postalCode) => {
    if (!Number.isFinite(postalCode)) return null;
    if (postalCode >= 10000 && postalCode <= 19999) return 'Stockholmsområdet';
    if (postalCode >= 20000 && postalCode <= 29999) return 'Skåne';
    if (postalCode >= 30000 && postalCode <= 32999) return 'Halland';
    if (postalCode >= 33000 && postalCode <= 36999) return 'Småland & Öland';
    if (postalCode >= 37000 && postalCode <= 37999) return 'Blekinge';
    if (postalCode >= 38000 && postalCode <= 39999) return 'Småland & Öland';
    if (postalCode >= 40000 && postalCode <= 44999) return 'Göteborgsområdet';
    if (postalCode >= 45000 && postalCode <= 48999) return 'Bohuslän & Dalsland';
    if (postalCode >= 50000 && postalCode <= 54999) return 'Skaraborg & Sjuhärad';
    if (postalCode >= 55000 && postalCode <= 57999) return 'Småland & Öland';
    if (postalCode >= 58000 && postalCode <= 60999) return 'Östergötland';
    if (postalCode >= 61000 && postalCode <= 61999) return 'Uppsala & Mälardalen';
    if (postalCode >= 62000 && postalCode <= 62999) return 'Småland & Öland';
    if (postalCode >= 63000 && postalCode <= 64999) return 'Uppsala & Mälardalen';
    if (postalCode >= 65000 && postalCode <= 71999) return 'Värmland, Örebro & Dalarna';
    if (postalCode >= 72000 && postalCode <= 76999) return 'Uppsala & Mälardalen';
    if (postalCode >= 77000 && postalCode <= 79999) return 'Värmland, Örebro & Dalarna';
    if (postalCode >= 80000 && postalCode <= 99999) return 'Norrland';
    return null;
  };

  const sceneFor = (name) => {
    let hash = 0;
    String(name || '').split('').forEach((char) => { hash = ((hash << 5) - hash) + char.charCodeAt(0); });
    return (Math.abs(hash) % 5) + 1;
  };

  const pageSize = () => window.matchMedia('(max-width: 767px)').matches ? 8 : (window.matchMedia('(max-width: 1023px)').matches ? 6 : 9);

  const initialize = (root) => {
    if (!root || root.dataset.gkDirectoryReady === 'true') return;
    root.dataset.gkDirectoryReady = 'true';

    const jsonUrl = root.dataset.golfclubJson;
    const regionsUrl = root.dataset.golfclubRegionsJson;
    const search = root.querySelector('[data-gk-directory-search]');
    const grid = root.querySelector('[data-gk-directory-grid]');
    // Page 2+ keeps its unique Shopify Liquid links after JS loads.
    const keepServerPagination = grid?.classList.contains('gk-directory-grid--paged') === true;
    const empty = root.querySelector('[data-gk-directory-empty]');
    const loadMore = root.querySelector('[data-gk-directory-load-more]');
    const regionMenu = root.querySelector('[data-gk-directory-region-menu]');
    const regionLists = [...root.querySelectorAll('[data-gk-directory-region-list-desktop], [data-gk-directory-region-list-mobile]')];
    const regionLabels = [...root.querySelectorAll('[data-gk-directory-region-label]')];
    const regionMobileTrigger = root.querySelector('[data-gk-directory-region-mobile-trigger]');
    const regionDialog = root.querySelector('[data-gk-directory-region-dialog]');
    const regionDialogTitle = root.querySelector('[data-gk-directory-region-title]');
    const regionDialogClose = root.querySelector('[data-gk-directory-region-close]');
    const sortToggle = root.querySelector('[data-gk-directory-sort-toggle]');
    const sortLabel = root.querySelector('[data-gk-directory-sort-label]');
    const locationIconTemplate = root.querySelector('[data-gk-directory-location-icon]');
    const locationIcon = locationIconTemplate ? locationIconTemplate.innerHTML : '';
    const chevronIconTemplate = root.querySelector('[data-gk-directory-chevron-icon]');
    const chevronIcon = chevronIconTemplate ? chevronIconTemplate.innerHTML : '<span aria-hidden="true">›</span>';

    let clubImages = {};
    try {
      clubImages = JSON.parse(root.querySelector('[data-gk-directory-images]')?.textContent || '{}');
    } catch {
      clubImages = {};
    }
    root.dataset.gkDirectoryImageCount = String(Object.keys(clubImages).length);

    // The HTML paginator keeps images for its own page. Fetch the remaining
    // image metadata only when a visitor searches, sorts or filters across pages.
    // This preserves the prior experience without a second Liquid pagination.
    let imageHydration = null;
    const hydrateOtherPageImages = () => {
      if (imageHydration) return imageHydration;
      const href = keepServerPagination
        ? '/pages/golfbanor'
        : root.querySelector('a[data-gk-directory-load-more]')?.getAttribute('href');
      if (!href) return Promise.resolve();
      imageHydration = (async () => {
        let nextHref = href;
        const visited = new Set();
        while (nextHref && visited.size < 8 && !visited.has(nextHref)) {
          visited.add(nextHref);
          const target = new URL(nextHref, window.location.origin);
          const current = new URL(window.location.href);
          if (target.pathname === current.pathname && target.search === current.search) break;
          const response = await fetch(target.href, { credentials: 'same-origin' });
          if (!response.ok) break;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const script = html.querySelector('[data-gk-directory-images]');
          if (script) {
            const extra = JSON.parse(script.textContent || '{}');
            if (extra && typeof extra === 'object' && !Array.isArray(extra)) Object.assign(clubImages, extra);
          }
          nextHref = html.querySelector('a[data-gk-directory-load-more]')?.getAttribute('href') || null;
        }
      })().then(() => {
        root.dataset.gkDirectoryImageCount = String(Object.keys(clubImages).length);
        if (grid.classList.contains('is-dynamic')) render();
      }).catch(() => {
        // The existing directory still works even if the image prefetch fails.
      });
      return imageHydration;
    };


    const state = {
      clubs: [],
      query: '',
      region: '',
      sort: 'asc',
      limit: pageSize(),
      regions: [],
      cityToRegion: {}
    };

    const buildCityToRegion = (citiesByRegion) => {
      const result = {};
      Object.entries(citiesByRegion || {}).forEach(([region, cities]) => {
        (cities || []).forEach((city) => {
          result[normalizeCity(city)] = region;
        });
      });
      return result;
    };

    const getClubRegion = (club) => {
      const explicitRegion = String(club?.region || club?.district || '').trim();
      if (explicitRegion) return explicitRegion;

      const cityRegion = state.cityToRegion[normalizeCity(club?.city)];
      if (cityRegion) return cityRegion;

      return getRegionFromPostalCode(getPostalCode(club));
    };

    const filteredClubs = () => {
      const query = state.query.toLocaleLowerCase('sv-SE');

      const items = state.clubs.filter((club) => {
        const name = String(club?.name || '').toLocaleLowerCase('sv-SE');
        const region = getClubRegion(club);
        return (!query || name.includes(query)) && (!state.region || region === state.region);
      });

      items.sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'sv-SE', { sensitivity: 'base' }));
      if (state.sort === 'desc') items.reverse();
      return items;
    };

    const cardMarkup = (club) => {
      const name = escapeHTML(club.name || 'Golfklubb');
      const region = getClubRegion(club);
      const location = escapeHTML(club.city || region || club.country || 'Sverige');
      const url = /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(club.slug || '') ? '/pages/golfbanor/' + club.slug : '';
      const scene = sceneFor(club.name);
      const imageUrl = clubImages[String(club.slug || '')];
      const hasImage = typeof imageUrl === 'string' && (/^(https?:)?\/\//i.test(imageUrl) || imageUrl.startsWith('/'));
      const mediaHtml = hasImage ? '<img src="' + escapeHTML(imageUrl) + '" alt="" width="360" height="240" loading="lazy" decoding="async">' : '';

      if (url) {
        return '<a class="gk-directory-card gk-list-row" data-gk-directory-card data-scene="' + scene + '" href="' + url + '" aria-label="' + name + ' – golfklubb hos Golfkuponger">' +
          '<div class="gk-directory-card__media gk-list-row__media" aria-hidden="true">' + mediaHtml + '</div>' +
          '<div class="gk-directory-card__copy gk-list-row__body"><h2>' + name + '</h2><p>' + locationIcon + '<span>' + location + '</span></p></div>' +
          '<span class="gk-directory-card__affordance gk-list-row__affordance" aria-hidden="true">' + chevronIcon + '</span>' +
          '</a>';
      }

      return '<article class="gk-directory-card gk-list-row" data-gk-directory-card data-scene="' + scene + '">' +
        '<div class="gk-directory-card__media gk-list-row__media" aria-hidden="true">' + mediaHtml + '</div>' +
        '<div class="gk-directory-card__copy gk-list-row__body"><h2>' + name + '</h2><p>' + locationIcon + '<span>' + location + '</span></p></div>' +
        '</article>';
    };

    const regionButtons = () => [...root.querySelectorAll('[data-gk-directory-region-value]')];

    const syncRegionUI = () => {
      regionLabels.forEach((label) => {
        label.textContent = state.region || 'Område';
      });

      regionButtons().forEach((button) => {
        const selected = (button.dataset.gkDirectoryRegionValue || '') === state.region;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    const syncSortUI = () => {
      const ascending = state.sort === 'asc';
      if (sortLabel) sortLabel.textContent = ascending ? 'A–Ö' : 'Ö–A';
      if (sortToggle) {
        sortToggle.setAttribute('aria-pressed', ascending ? 'false' : 'true');
        sortToggle.setAttribute('aria-label', ascending ? 'Sortering A till Ö. Tryck för Ö till A.' : 'Sortering Ö till A. Tryck för A till Ö.');
      }
    };

    const render = () => {
      const items = filteredClubs();
      const visible = items.slice(0, state.limit);

      grid.classList.add('is-dynamic');
      grid.innerHTML = visible.map(cardMarkup).join('');
      empty.hidden = items.length > 0;
      grid.hidden = items.length === 0;
      loadMore.hidden = visible.length >= items.length;

      syncRegionUI();
      syncSortUI();
    };

    const resetLimitAndRender = () => {
      state.limit = pageSize();
      render();
      hydrateOtherPageImages();
    };

    const renderRegions = () => {
      if (!regionLists.length) return;

      const options = [''].concat(state.regions);
      const markup = options.map((region) => {
        const value = escapeHTML(region);
        const label = escapeHTML(region || 'Alla områden');
        return '<button type="button" class="gk-directory-region-option" data-gk-directory-region-value="' + value + '" aria-pressed="false"><span>' + label + '</span><span class="gk-directory-region-radio" aria-hidden="true"></span></button>';
      }).join('');

      regionLists.forEach((list) => {
        list.innerHTML = markup;
      });

      regionButtons().forEach((button) => {
        button.addEventListener('click', () => {
          state.region = button.dataset.gkDirectoryRegionValue || '';
          if (regionMenu) regionMenu.open = false;
          if (regionDialog?.open) regionDialog.close();
          resetLimitAndRender();
        });
      });

      syncRegionUI();
    };

    Promise.all([
      fetch(jsonUrl).then((response) => response.ok ? response.json() : Promise.reject(new Error('Kunde inte läsa golfbanor.json'))),
      fetch(regionsUrl).then((response) => response.ok ? response.json() : Promise.reject(new Error('Kunde inte läsa golfbanor-regioner.json')))
    ])
      .then(([clubs, regionConfig]) => {
        state.clubs = Array.isArray(clubs) ? clubs.filter((club) => club && club.active !== false && (club.anlaggningstyp === 'golfbana' || club.visa_i_golfbanor === true)) : [];
        state.regions = Array.isArray(regionConfig?.regions) ? regionConfig.regions : [];
        state.cityToRegion = buildCityToRegion(regionConfig?.citiesByRegion);
        const initialRegion = new URLSearchParams(window.location.search).get('region');
        if (state.regions.includes(initialRegion)) state.region = initialRegion;
        renderRegions();
        syncRegionUI();
        if (!keepServerPagination) {
          render();
          if (state.region) hydrateOtherPageImages();
        }
      })
      .catch(() => {
        // Keep the server-rendered fallback and its pagination link usable.
        root.dataset.gkDirectoryReady = 'fallback';
      });

    search?.addEventListener('input', () => {
      state.query = search.value.trim();
      resetLimitAndRender();
    });

    sortToggle?.addEventListener('click', () => {
      state.sort = state.sort === 'asc' ? 'desc' : 'asc';
      resetLimitAndRender();
    });

    const setRegionDialogScrollLock = (locked) => {
      document.documentElement.classList.toggle('gk-region-dialog-open', locked);
      document.body?.classList.toggle('gk-region-dialog-open', locked);
    };

    regionMobileTrigger?.addEventListener('click', () => {
      if (!regionDialog || typeof regionDialog.showModal !== 'function') return;
      regionDialog.showModal();
      setRegionDialogScrollLock(true);
      requestAnimationFrame(() => {
        regionDialogTitle?.focus({ preventScroll: true });
      });
    });

    regionDialogClose?.addEventListener('click', () => {
      regionDialog?.close();
    });

    regionDialog?.addEventListener('click', (event) => {
      if (event.target === regionDialog) regionDialog.close();
    });

    regionDialog?.addEventListener('close', () => {
      setRegionDialogScrollLock(false);
      regionMobileTrigger?.focus({ preventScroll: true });
    });

    regionDialog?.addEventListener('cancel', () => {
      setRegionDialogScrollLock(false);
    });

    document.addEventListener('click', (event) => {
      if (regionMenu?.open && !regionMenu.contains(event.target)) regionMenu.open = false;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && regionMenu?.open) regionMenu.open = false;
    });

    loadMore?.addEventListener('click', (event) => {
      // Page 2+ must use the native next-page link until a user starts filtering.
      if (keepServerPagination && !grid.classList.contains('is-dynamic')) return;
      // If enhancement data did not load yet, preserve the native fallback link.
      if (!state.clubs.length) return;
      event.preventDefault();
      state.limit += pageSize();
      render();
      if (state.limit >= 200) hydrateOtherPageImages();
    });

    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        if (keepServerPagination && !grid.classList.contains('is-dynamic')) return;
        if (state.limit <= 9) state.limit = pageSize();
        render();
      });
    }, { passive: true });
  };

  const initializeAll = () => document.querySelectorAll(rootSelector).forEach(initialize);
  document.addEventListener('shopify:section:load', initializeAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
